import { render, staticRenderFns } from "./Inscriptions.vue?vue&type=template&id=fe92ff3c&scoped=true"
import script from "./Inscriptions.vue?vue&type=script&lang=js"
export * from "./Inscriptions.vue?vue&type=script&lang=js"
import style0 from "./Inscriptions.vue?vue&type=style&index=0&id=fe92ff3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe92ff3c",
  null
  
)

export default component.exports